[
  {
    "name": "AssortGlobalCache",
    "description": "Don't use",
    "visible": true
  },
  {
    "name": "AssortmentDV",
    "description": "Option payante: afficher la DV dans le menu Référencement",
    "visible": true
  },
  {
    "name": "AssortReferenceCache",
    "description": "Don't use",
    "visible": true
  },
  {
    "name": "Currency",
    "description": "",
    "visible": true
  },
  {
    "name": "DashBoardNbDayActivationMax",
    "description": "",
    "visible": true
  },
  {
    "name": "DashBoardNbDayActivationMin",
    "description": "",
    "visible": true
  },
  {
    "name": "DashBoardNbDayMax",
    "description": "",
    "visible": true
  },
  {
    "name": "DashBoardNbDayMin",
    "description": "",
    "visible": true
  },
  {
    "name": "DashboardObjectiveByBrandLevel",
    "description": "",
    "visible": true
  },
  {
    "name": "DashBoardPctMax",
    "description": "",
    "visible": true
  },
  {
    "name": "DashBoardPctMin",
    "description": "",
    "visible": true
  },
  {
    "name": "EnableReportings",
    "description": "Enable reportings on eCOS Assort. If not activated, users won't have access to reportings.",
    "visible": true
  },
  {
    "name": "FDRSimulationPeriodSellIn",
    "description": "",
    "visible": true
  },
  {
    "name": "MaxPeriodSelection",
    "description": "Maximum number of periods selectable on reportings and listing.",
    "visible": true
  },
  {
    "name": "MaxSimulationAccountSelection",
    "description": "Maximum number of accounts selectable.",
    "visible": true
  },
  {
    "name": "MaxSimulationPeriodSelection",
    "description": "Maximum number of periods selectable on simulation.",
    "visible": true
  },
  {
    "name": "MaxUserProcessAss",
    "description": "Maximum number of users for 'Assortiment' process.",
    "visible": true
  },
  {
    "name": "MaxUserProcessSimulation",
    "description": "Maximum number of users for 'Simulation' process.",
    "visible": true
  },
  {
    "name": "ObjEgalAgree",
    "description": "",
    "visible": true
  },
  {
    "name": "ObjGreaterAgree",
    "description": "",
    "visible": true
  },
  {
    "name": "ObjLessAgree",
    "description": "",
    "visible": true
  },
  {
    "name": "PeriodPanel",
    "description": "",
    "visible": true
  },
  {
    "name": "ProductLevelMax",
    "description": "Category level selectable for products. If 2, level 2, 3, 4 and more will be selectable.",
    "visible": true
  },
  {
    "name": "RankLevel",
    "description": "Category level for ranking.",
    "visible": true
  },
  {
    "name": "ReportAccountSegmentEvolutionAddReference",
    "description": "",
    "visible": true
  },
  {
    "name": "ReportAccountSegmentEvolutionGreaterReference",
    "description": "",
    "visible": true
  },
  {
    "name": "ReportAccountSegmentEvolutionLessReference",
    "description": "",
    "visible": true
  },
  {
    "name": "ReportAccountSegmentEvolutionRemoveReference",
    "description": "",
    "visible": true
  },
  {
    "name": "ReportAssortDiffusionThreshold",
    "description": "",
    "visible": true
  },
  {
    "name": "ReportBadColor",
    "description": "",
    "visible": true
  },
  {
    "name": "ReportGoodColor",
    "description": "",
    "visible": true
  },
  {
    "name": "ReportScoreCardEvolutionThreshold",
    "description": "",
    "visible": true
  },
  {
    "name": "ReportScoreCardGapThreshold",
    "description": "",
    "visible": true
  },
  {
    "name": "SegmentLevel",
    "description": "Category level for ND/WD",
    "visible": true
  },
  {
    "name": "SingleKeyCustomerCode",
    "description": "Product key is customer code.",
    "visible": true
  },
  {
    "name": "SingleKeyEAN",
    "description": "Product key is EAN.",
    "visible": true
  },
  {
    "name": "SplitSellInLevel",
    "description": "Category level for sell-in split.",
    "visible": true
  },
  {
    "name": "AcceptedFileExtension",
    "description": "List of authorized file extensions.",
    "visible": true
  },
  {
    "name": "CanSpecializeEditorial",
    "description": "",
    "visible": false
  },
  {
    "name": "CanUseGridViewExcelExport",
    "description": "",
    "visible": false
  },
  {
    "name": "CanUseGridViewSpecificExcelExport",
    "description": "",
    "visible": false
  },
  {
    "name": "MaximumSizePerFile",
    "description": "Maximum size per file.",
    "visible": true
  },
  {
    "name": "MaximumStorageSize",
    "description": "Maximum storage size.",
    "visible": true
  },
  {
    "name": "MaxUserProcessDoc",
    "description": "Maximum number of users for 'Document' process.",
    "visible": true
  },
  {
    "name": "OfflineMode",
    "description": "",
    "visible": false
  },
  {
    "name": "PreviewFileExtension",
    "description": "List of files extensios that will have preview.",
    "visible": true
  },
  {
    "name": "UseRestriction",
    "description": "",
    "visible": false
  },
  {
    "name": "PasswordExpirationDays",
    "description": "Number of days before password expiration (from last password modification).",
    "visible": true
  },
  {
    "name": "PasswordMaxFailed",
    "description": "Number of trials before account blocking.",
    "visible": true
  },
  {
    "name": "PasswordMaxHistory",
    "description": "Number of passwords logged and impossible to reuse.",
    "visible": true
  },
  {
    "name": "PasswordMinLength",
    "description": "Minimum number of characters.",
    "visible": true
  },
  {
    "name": "PasswordMinLowerCase",
    "description": "Minimum number of lower case.",
    "visible": true
  },
  {
    "name": "PasswordMinNumbers",
    "description": "Minimum number of numbers.",
    "visible": true
  },
  {
    "name": "PasswordMinSpecialChars",
    "description": "Minimum number of special characters.",
    "visible": true
  },
  {
    "name": "PasswordMinUpperCase",
    "description": "Minimum number of upper case.",
    "visible": true
  },
  {
    "name": "AddDeliveryLocationType",
    "description": "",
    "visible": false
  },
  {
    "name": "AllowAgendaSynch",
    "description": "",
    "visible": true
  },
  {
    "name": "BusinessDays",
    "description": "",
    "visible": false
  },
  {
    "name": "CanChangeConstatSettingsAnim",
    "description": "",
    "visible": false
  },
  {
    "name": "CanChangeConstatSettingsMerch",
    "description": "",
    "visible": false
  },
  {
    "name": "CanChangeConstatSettingsRent",
    "description": "",
    "visible": false
  },
  {
    "name": "CanChangeEvaluationSettingsAnim",
    "description": "",
    "visible": false
  },
  {
    "name": "CanChangeEvaluationSettingsMerch",
    "description": "",
    "visible": false
  },
  {
    "name": "CanChangeEvaluationSettingsRent",
    "description": "",
    "visible": false
  },
  {
    "name": "CanFollowUpProviders",
    "description": "",
    "visible": false
  },
  {
    "name": "CanInformRetailers",
    "description": "",
    "visible": false
  },
  {
    "name": "CanSelectMultipleProviders",
    "description": "",
    "visible": false
  },
  {
    "name": "CanSelectMultipleProvidersAnim",
    "description": "",
    "visible": false
  },
  {
    "name": "CanSelectMultipleProvidersMerch",
    "description": "",
    "visible": false
  },
  {
    "name": "CanSelectMultipleProvidersRent",
    "description": "",
    "visible": false
  },
  {
    "name": "CanSendDestructionInstructionOnProductDeletion",
    "description": "",
    "visible": false
  },
  {
    "name": "CanSetCampaignStoreMandatory",
    "description": "",
    "visible": false
  },
  {
    "name": "CanSetDynamicAttributes",
    "description": "",
    "visible": false
  },
  {
    "name": "CanSetKit",
    "description": "",
    "visible": false
  },
  {
    "name": "CanSetMissionResourcesAmount",
    "description": "",
    "visible": false
  },
  {
    "name": "CanSetMultiProviders",
    "description": "",
    "visible": false
  },
  {
    "name": "CanSetProductLinksAnim",
    "description": "",
    "visible": false
  },
  {
    "name": "CanSetProductLinksMaterial",
    "description": "",
    "visible": false
  },
  {
    "name": "CanSetProductLinksMerch",
    "description": "",
    "visible": false
  },
  {
    "name": "CanSetProductLinksRent",
    "description": "",
    "visible": false
  },
  {
    "name": "CanSetRestrictionOnCampaign",
    "description": "",
    "visible": false
  },
  {
    "name": "CanShareQuota",
    "description": "",
    "visible": false
  },
  {
    "name": "CanSpecializeEditorial",
    "description": "",
    "visible": true
  },
  {
    "name": "CanUseAdvancedReplenishment",
    "description": "",
    "visible": false
  },
  {
    "name": "CanUseCampaignArea",
    "description": "",
    "visible": false
  },
  {
    "name": "CanUseGridViewExcelExport",
    "description": "",
    "visible": false
  },
  {
    "name": "CanUseGridViewSpecificExcelExport",
    "description": "",
    "visible": false
  },
  {
    "name": "CanUseLateCancellation",
    "description": "Users will be able to us late cancellation (quota is not returned).",
    "visible": true
  },
  {
    "name": "CanUseLiningGraphic",
    "description": "",
    "visible": false
  },
  {
    "name": "CanUseMerchAnalyser",
    "description": "",
    "visible": false
  },
  {
    "name": "CanUseMerchAssistant",
    "description": "",
    "visible": false
  },
  {
    "name": "CanUseMerchBudget",
    "description": "",
    "visible": false
  },
  {
    "name": "CanUseOnCampaign",
    "description": "",
    "visible": false
  },
  {
    "name": "CanUseOutTreshold",
    "description": "",
    "visible": false
  },
  {
    "name": "CanUseQRCodeTab",
    "description": "",
    "visible": false
  },
  {
    "name": "CanUseTeamWork",
    "description": "",
    "visible": false
  },
  {
    "name": "CanUseValidationAnim",
    "description": "",
    "visible": false
  },
  {
    "name": "CanUseValidationMaterial",
    "description": "",
    "visible": false
  },
  {
    "name": "CanUseValidationMerch",
    "description": "",
    "visible": false
  },
  {
    "name": "CanUseValidationRent",
    "description": "",
    "visible": false
  },
  {
    "name": "CouplingPeriodDefault",
    "description": "",
    "visible": false
  },
  {
    "name": "DestructionOrders",
    "description": "",
    "visible": false
  },
  {
    "name": "DisableQuotaChecks",
    "description": "Disable of quota checks. Use it only for reorganisation !",
    "visible": true
  },
  {
    "name": "ESR",
    "description": "ESR are activated.",
    "visible": true
  },
  {
    "name": "ExcludedDays",
    "description": "",
    "visible": false
  },
  {
    "name": "GDPR",
    "description": "",
    "visible": true
  },
  {
    "name": "Grouping",
    "description": "",
    "visible": false
  },
  {
    "name": "MailAlert",
    "description": "",
    "visible": false
  },
  {
    "name": "MaxRemoteCall.google.maps.DirectionsService",
    "description": "Use to calculate directions",
    "visible": true
  },
  {
    "name": "MaxRemoteCall.google.maps.DistanceMatrixService",
    "description": "Distance Matrix service computes travel distance and journey duration between multiple origins and destinations using a given mode of travel.",
    "visible": true
  },
  {
    "name": "MaxRemoteCall.google.maps.Geocoder",
    "description": "Geocoding is the process of converting addresses into geographic coordinates.",
    "visible": true
  },
  {
    "name": "MaxRemoteCall.google.maps.Map",
    "description": "",
    "visible": true
  },
  {
    "name": "MaxRemoteCall.google.maps.TrafficLayer",
    "description": "Map that uses a traffic layer to show real-time traffic information.",
    "visible": true
  },
  {
    "name": "MaxUserProcessAgenda",
    "description": "",
    "visible": false
  },
  {
    "name": "MaxUserProcessAnim",
    "description": "Maximum number of users for 'Animation' process.",
    "visible": true
  },
  {
    "name": "MaxUserProcessMaterial",
    "description": "Maximum number of users for 'Material' process.",
    "visible": true
  },
  {
    "name": "MaxUserProcessRent",
    "description": "Maximum number of users for 'Rent' process.",
    "visible": true
  },
  {
    "name": "MaxUserProcessSFA",
    "description": "Maximum number of users for 'SFA' process.",
    "visible": true
  },
  {
    "name": "MaxUserProcessSpecificMerch",
    "description": "Maximum number of users for 'Merch' process.",
    "visible": true
  },
  {
    "name": "MOBEYE",
    "description": "",
    "visible": true
  },
  {
    "name": "OfflineMode",
    "description": "",
    "visible": false
  },
  {
    "name": "OrderHistoricalMonths",
    "description": "",
    "visible": false
  },
  {
    "name": "PortalPSP",
    "description": "",
    "visible": false
  },
  {
    "name": "Product_Autogeneration",
    "description": "",
    "visible": true
  },
  {
    "name": "Product_Autogeneration_Create_Only",
    "description": "",
    "visible": true
  },
  {
    "name": "Product_Autogeneration_No_Separator",
    "description": "",
    "visible": true
  },
  {
    "name": "ProductAssortOrder",
    "description": "Assort order is activated.",
    "visible": true
  },
  {
    "name": "ProductUniqueReference",
    "description": "",
    "visible": true
  },
  {
    "name": "ReadRestrictionByDefault",
    "description": "",
    "visible": false
  },
  {
    "name": "Reappro",
    "description": "",
    "visible": false
  },
  {
    "name": "Reorganisation",
    "description": "",
    "visible": false
  },
  {
    "name": "RSWAutoRetrieved",
    "description": "",
    "visible": true
  },
  {
    "name": "RSWExpeditionRule",
    "description": "",
    "visible": false
  },
  {
    "name": "RSWVersion",
    "description": "",
    "visible": false
  },
  {
    "name": "SAV",
    "description": "",
    "visible": true
  },
  {
    "name": "SFA",
    "description": "Full = SFA is activated.",
    "visible": true
  },
  {
    "name": "SFA_GMAP",
    "description": "Users can use Maps.",
    "visible": true
  },
  {
    "name": "SFA_SYNCH_STORE_POTENTIAL-GROUP_DELIVERYLOCATION",
    "description": "",
    "visible": true
  },
  {
    "name": "SFA_VISIT_WORKFLOW_STEPS",
    "description": "",
    "visible": false
  },
  {
    "name": "SFARestrictPOSDnCalculToStated",
    "description": "",
    "visible": true
  },
  {
    "name": "SFAStatementLevel",
    "description": "Product category level for SFA statement.",
    "visible": true
  },
  {
    "name": "Store_Autogeneration",
    "description": "",
    "visible": true
  },
  {
    "name": "Store_Autogeneration_Create_Only",
    "description": "",
    "visible": true
  },
  {
    "name": "SwitchQuota",
    "description": "",
    "visible": false
  },
  {
    "name": "UseRestriction",
    "description": "",
    "visible": false
  },
  {
    "name": "Validation",
    "description": "",
    "visible": false
  },
  {
    "name": "ValidationWithThreshold",
    "description": "",
    "visible": false
  },
  {
    "name": "VisitDuration",
    "description": "",
    "visible": true
  },
  {
    "name": "WaveTuning",
    "description": "",
    "visible": false
  },
  {
    "name": "WebAppSalesFO",
    "description": "",
    "visible": true
  },
  {
    "name": "WorkingDays",
    "description": "",
    "visible": false
  },
  {
    "name": "YearStartDate",
    "description": "",
    "visible": true
  },
  {
    "name": "AllowAgendaSynch",
    "description": "Allow to activate synchronization with external agendas",
    "visible": true
  }
]